import React, { useContext } from 'react';

import { StyleSheet, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';
export default function DyteLiveStreamIndicator({
  meeting,
  iconPack = defaultIconPack,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size = 'sm',
  // eslint-disable-next-line react-hooks/rules-of-hooks, @typescript-eslint/no-unused-vars
  t = useLanguage(),
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  iconPack = iconPack ?? defaultIconPack;
  const livestreamState = useDyteSelector((m) =>
    m.livestream ? m.livestream.state : null
  );
  const livestreamStage = useDyteSelector((m) => m.stage.status);
  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      padding: 16,
      marginTop: 3,
      marginLeft: 8,
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
  });
  if (meeting.meta.viewType !== 'LIVESTREAM') return null;
  if (livestreamState === 'LIVESTREAMING' && livestreamStage === 'OFF_STAGE')
    return (
      <View style={styles.container}>
        <SvgXml
          xml={iconPack.start_livestream.replace('currentColor', colors.danger)}
          width={25}
          height={25}
        />
        {/* eslint-disable-next-line react-native/no-inline-styles */}
        <DyteText style={{ marginLeft: 8 }}>Live</DyteText>
      </View>
    );
  else return <View />;
}
